import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconBlockLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.002 21.5a9.254 9.254 0 0 1-3.706-.748 9.596 9.596 0 0 1-3.016-2.03 9.595 9.595 0 0 1-2.032-3.016 9.246 9.246 0 0 1-.748-3.704c0-1.314.25-2.55.748-3.706a9.596 9.596 0 0 1 2.03-3.016 9.594 9.594 0 0 1 3.016-2.032 9.246 9.246 0 0 1 3.704-.748c1.314 0 2.55.25 3.706.748a9.596 9.596 0 0 1 3.017 2.03 9.594 9.594 0 0 1 2.03 3.016 9.247 9.247 0 0 1 .749 3.704 9.27 9.27 0 0 1-.748 3.706 9.596 9.596 0 0 1-2.03 3.017 9.595 9.595 0 0 1-3.016 2.03 9.247 9.247 0 0 1-3.704.749ZM12 20a7.84 7.84 0 0 0 2.71-.476 7.93 7.93 0 0 0 2.382-1.378L5.854 6.908A8.125 8.125 0 0 0 4.48 9.289 7.77 7.77 0 0 0 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Zm6.146-2.908a7.93 7.93 0 0 0 1.378-2.381A7.84 7.84 0 0 0 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-.94 0-1.846.157-2.717.471a7.618 7.618 0 0 0-2.375 1.383l11.238 11.238Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconBlockLine;
